import { h } from '../lib/dom.js';
import { getState, setSilent } from '../store.js';
import { cancelAddRecipient, saveRecipient, setRecipientEditField, validateRecipientAddressBlur } from '../actions.js';
import { t } from '../i18n/index.js';

export function renderAddRecipientModal() {
  const s = getState();
  // feature-harden.md 6.3: saveRecipient() now opens the confirmReveal
  // re-auth modal on top of this one (showAddRecipient stays true so
  // canceling re-auth returns here). Suppressing this modal's own render
  // while that's active keeps exactly one modal-card in the DOM — two
  // stacked modal-scrims would break main.js's Escape-key/Tab-focus-trap
  // routing, which both key off the first modal-card found.
  if (!s.showAddRecipient || s.showConfirmReveal) return null;
  const editing = s.recipientEdit;
  const nameValue = editing ? editing.name : s.newRecipName;
  const addressValue = editing ? editing.address : s.newRecipAddress;
  const onNameInput = editing
    ? (e) => setRecipientEditField('name', e.target.value)
    : (e) => setSilent({ newRecipName: e.target.value });
  const onAddressInput = editing
    ? (e) => setRecipientEditField('address', e.target.value)
    : (e) => setSilent({ newRecipAddress: e.target.value });

  // modal-scrim-panel: desktop-only inline side panel instead of a
  // centered overlay (feature-ui.md's Desktop section) — see style.css.
  return h('div', { class: 'modal-scrim modal-scrim-panel' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, editing ? t('modals.addRecipient.editTitle') : t('modals.addRecipient.addTitle')),
      h('input', { placeholder: t('modals.addRecipient.namePlaceholder'), value: nameValue, oninput: onNameInput, onkeydown: (e) => { if (e.key === 'Enter') saveRecipient(); } }),
      h('input', {
        placeholder: t('modals.addRecipient.addressPlaceholder'), value: addressValue, class: 'mono', oninput: onAddressInput,
        onblur: validateRecipientAddressBlur, onkeydown: (e) => { if (e.key === 'Enter') saveRecipient(); }
      }),
      h('div', { class: 'field-error' }, s.newRecipError || ''),
      h('div', { class: 'btn-row' }, [
        h('button', { class: 'btn btn-secondary', onclick: cancelAddRecipient }, t('common.cancel')),
        h('button', { class: 'btn btn-primary', onclick: saveRecipient }, editing ? t('modals.addRecipient.saveChanges') : t('modals.addRecipient.save'))
      ])
    ])
  ]);
}
